import { BaserowClient } from "./baserow-client";

/**
 * Operations for managing Baserow dashboards.
 */
export class DashboardOperations {
  constructor(private client: BaserowClient) {}
  
  // Dashboard methods will be implemented here
} 